import LocalLoginPage from "./localLogin";

interface Props {}

const ExtensionPage = (props: Props) => {
  return (
    <LocalLoginPage
      port={2995}
      successMessage="You are now logged in, please return to the Tempo extension..."
      {...props}
    />
  );
};

export default ExtensionPage;
